import ActionsList from 'core/actions/Actions.list';
import { actionCoreApi } from 'core/utils/api';
import { actionErrorNotifier } from 'core/utils/helpers';
import { dispatcherActionType } from 'core/utils/interfaces';
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper';

export const updateClientAuthCertLogin = (formData, accountId: string, message: string): dispatcherActionType => actionErrorNotifier(
  actionCoreApi(
    ActionsList.EnableClientAuthCertLogin,
    HTTPUrlHelper.getEnableCacAPI(accountId),
    'PUT',
    formData
  ), true,
  {
    title: '',
    message: message
  }
)